export const USER_IS_TRIAL = 'istrial';
